/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from './pager.component.ngfactory';
import * as i3 from '@swimlane/ngx-datatable/release/components/footer/pager.component';
import * as i4 from '@swimlane/ngx-datatable/release/components/footer/footer.component';
const styles_DataTableFooterComponent:any[] = ([] as any[]);
export const RenderType_DataTableFooterComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_DataTableFooterComponent,data:{}});
function View_DataTableFooterComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n      ']))],(null as any),
      (null as any));
}
function View_DataTableFooterComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),2,(null as any),
      View_DataTableFooterComponent_2)),i0.ɵdid(1,540672,(null as any),0,i1.NgTemplateOutlet,
      [i0.ViewContainerRef],{ngTemplateOutlet:[0,'ngTemplateOutlet'],ngOutletContext:[1,
          'ngOutletContext']},(null as any)),i0.ɵpod(2,{rowCount:0,pageSize:1,selectedCount:2,
      curPage:3,offset:4}),(_l()(),i0.ɵand(0,(null as any),(null as any),0))],(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.footerTemplate.template;
    const currVal_1:any = _ck(_v,2,0,_co.rowCount,_co.pageSize,_co.selectedCount,_co.curPage,
        _co.offset);
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_DataTableFooterComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted(1,(null as any),['\n          ',' ',' / \n        ']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.selectedCount.toLocaleString();
        const currVal_1:any = _co.selectedMessage;
        _ck(_v,1,0,currVal_0,currVal_1);
      });
}
function View_DataTableFooterComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),4,'div',[['class',
      'page-count']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['\n        '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_DataTableFooterComponent_4)),i0.ɵdid(3,
          16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i0.ɵted(4,(null as any),['\n        ',
          ' ','\n      ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.selectedMessage;
    _ck(_v,3,0,currVal_0);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.rowCount.toLocaleString();
    const currVal_2:any = _co.totalMessage;
    _ck(_v,4,0,currVal_1,currVal_2);
  });
}
function View_DataTableFooterComponent_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),2,'datatable-pager',
      [['class','datatable-pager']],[[8,'hidden',0]],[[(null as any),'change']],(_v,
          en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('change' === en)) {
          const pd_0:any = ((<any>_co.page.emit($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_DataTablePagerComponent_0,i2.RenderType_DataTablePagerComponent)),
      i0.ɵdid(1,49152,(null as any),0,i3.DataTablePagerComponent,([] as any[]),{pagerLeftArrowIcon:[0,
          'pagerLeftArrowIcon'],pagerRightArrowIcon:[1,'pagerRightArrowIcon'],pagerPreviousIcon:[2,
          'pagerPreviousIcon'],pagerNextIcon:[3,'pagerNextIcon'],size:[4,'size'],count:[5,
          'count'],page:[6,'page']},{change:'change'}),(_l()(),i0.ɵted(-1,(null as any),
          ['\n      ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.pagerLeftArrowIcon;
    const currVal_2:any = _co.pagerRightArrowIcon;
    const currVal_3:any = _co.pagerPreviousIcon;
    const currVal_4:any = _co.pagerNextIcon;
    const currVal_5:any = _co.pageSize;
    const currVal_6:any = _co.rowCount;
    const currVal_7:any = _co.curPage;
    _ck(_v,1,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:boolean = !_co.isVisible;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_DataTableFooterComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(2,[(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(1,
      0,(null as any),(null as any),12,'div',[['class','datatable-footer-inner']],
      [[4,'height','px']],(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(2,278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,
          i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,'ngClass']},(null as any)),
      i0.ɵpod(3,{'selected-count':0}),(_l()(),i0.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DataTableFooterComponent_1)),
      i0.ɵdid(6,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DataTableFooterComponent_3)),
      i0.ɵdid(9,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DataTableFooterComponent_5)),
      i0.ɵdid(12,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(_ck,_v) => {
    var _co:i4.DataTableFooterComponent = _v.component;
    const currVal_1:any = 'datatable-footer-inner';
    const currVal_2:any = _ck(_v,3,0,_co.selectedMessage);
    _ck(_v,2,0,currVal_1,currVal_2);
    const currVal_3:any = _co.footerTemplate;
    _ck(_v,6,0,currVal_3);
    const currVal_4:boolean = !_co.footerTemplate;
    _ck(_v,9,0,currVal_4);
    const currVal_5:boolean = !_co.footerTemplate;
    _ck(_v,12,0,currVal_5);
  },(_ck,_v) => {
    var _co:i4.DataTableFooterComponent = _v.component;
    const currVal_0:any = _co.footerHeight;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_DataTableFooterComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'datatable-footer',
      [['class','datatable-footer']],(null as any),(null as any),(null as any),View_DataTableFooterComponent_0,
      RenderType_DataTableFooterComponent)),i0.ɵdid(1,49152,(null as any),0,i4.DataTableFooterComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const DataTableFooterComponentNgFactory:i0.ComponentFactory<i4.DataTableFooterComponent> = i0.ɵccf('datatable-footer',
    i4.DataTableFooterComponent,View_DataTableFooterComponent_Host_0,{footerHeight:'footerHeight',
        rowCount:'rowCount',pageSize:'pageSize',offset:'offset',pagerLeftArrowIcon:'pagerLeftArrowIcon',
        pagerRightArrowIcon:'pagerRightArrowIcon',pagerPreviousIcon:'pagerPreviousIcon',
        pagerNextIcon:'pagerNextIcon',totalMessage:'totalMessage',footerTemplate:'footerTemplate',
        selectedCount:'selectedCount',selectedMessage:'selectedMessage'},{page:'page'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/src/$$_gendir/node_modules/@swimlane/ngx-datatable/release/components/footer/footer.component.ngfactory.ts